<template>
  <div class="form-group">
    <meta-label
      :disabled="disabled"
      :has-error="errors.has(name)"
      :inputId="id"
      :label="label"
      :required="required"
    />
    </meta-label>

    <input
      type="text"
      class="form-control"
      ref="input"
      v-validate="{ rules: rules }"
      :class="classes"
      :data-vv-as="label"
      :disabled="disabled"
      :id="id"
      :maxlength="maxlength"
      :name="name"
      :pattern="pattern"
      :placeholder="placeholder"
      :readonly="readonly"
      :value="value"
      v-on:input="updateValue($event.target.value)"
    />
    <span v-show="errors.has(name)" class="help text-danger">{{ errors.first(name) }}</span>
  </div>
</template>

<script>
  import MetaLabel from 'meta-label';
  import MetaTextualInputMixin from 'meta-textual-input-mixin';
  import { validarUrl } from './custom-validations';

  export default {
    name: 'MetaURL',

    components: {
      MetaLabel,
    },

    mixins: [
      MetaTextualInputMixin,
    ],

    computed: {
      rules() {
        return Object.assign({}, this.validations, {
          required: this.required,
          max: this.maxlength,
          min: this.minlength,
          regex: this.pattern,
          validarUrl: true,
        });
      }
    },

    created() {
      this.$validator.extend('validarUrl', validarUrl);
    },
  };
</script>



// WEBPACK FOOTER //
// App.vue?1aa6e46e